<template>
  <div class="d-flex flex-column">
    <div class="grid--three-column">
      <ValidatedInput
        rules="required"
        label="Card Number"
        mask="cc"
        id="cardNumber"
        :value="formFields.cardNumber"
        :errors="errorResolver('cardNumber')"
        @input="newValue => handleInputChange({ field: 'cardNumber', newValue })"
      />
      <ValidatedInput
        rules="required"
        label="Expiry Date"
        id="expirationDate"
        mask="exp"
        :value="formFields.expirationDate"
        :errors="errorResolver('expirationDate')"
        @input="newValue => handleInputChange({ field: 'expirationDate', newValue })"
      />
      <ValidatedInput
        rules="required"
        label="CVV"
        mask="cvv"
        id="cvv"
        :value="formFields.cardCode"
        :errors="errorResolver('cardCode')"
        @input="newValue => handleInputChange({ field: 'cardCode', newValue })"
      />
    </div>

    <div class="grid--two-column mt-2">
      <div>
        <ValidatedInput
          rules="required"
          label="Name on Card"
          id="cardholderName"
          :value="formFields.cardholderName"
          :errors="errorResolver('cardholderName')"
          @input="newValue => handleInputChange({ field: 'cardholderName', newValue })"
          class="mb-0"
        />
        <div v-if="nameSuggestion" @click="handleInputChange({ field: 'cardholderName',  newValue: nameSuggestion })">
          <span class="text-muted">Customer name:</span> <span class="text-primary clickable">{{nameSuggestion}}</span>
        </div>
      </div>

      <ValidatedInput
        rules="required"
        label="Country"
        id="country"
        :value="formFields.country || 'US'"
        :errors="errorResolver('country')"
        @input="newValue => handleInputChange({ field: 'country', newValue })"
        class="mb-0"
      />
    </div>

    <div class="grid--three-column  mt-4" style="grid-template-columns:  1fr 2fr;">

      <ValidatedInput
        rules="required"
        label="Address"
        id="address"
        :value="formFields.address"
        :errors="errorResolver('address')"
        @input="newValue => handleInputChange({ field: 'address', newValue })"
        class="mb-0"
      />

      <div>
        <div class="grid--two-column">
          <ValidatedInput
            rules="required"
            label="City"
            id="city"
            :value="formFields.city"
            :errors="errorResolver('city')"
            @input="newValue => handleInputChange({ field: 'city', newValue })"
            class="mb-0"
          />

          <ValidatedInput
            rules="required"
            label="Zip"
            id="zip"
            :value="formFields.zip"
            :errors="errorResolver('zip')"
            @input="newValue => handleInputChange({ field: 'zip', newValue })"
            class="mb-0"
          />
        </div>
        <div  class="grid--two-column position-relative">
          <LocationSuggestions
            v-if="show_suggesions"
            :city="formFields.city"
            :zip="formFields.zip"
            @select="e => handleSuggestion(e)"
          />
        </div>
      </div>
    </div>

    <div v-if="addressSuggestions.length" class="mb-4">
      <div v-for="suggestion in addressSuggestions" :key="suggestion.type" @click="applyAddressSuggestion(suggestion)">
        <span class="text-muted" style="width: 125px; display: inline-block;"> {{ suggestion.type }} Location:</span>
        <span class="text-primary clickable"> {{ suggestion.address }}, {{ suggestion.city }}, {{suggestion.state}} {{ suggestion.zip }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ValidatedInput from '@/components/shared/ValidatedInput';
import LocationSuggestions from '@/components/shared/formFields/LocationSuggestions.vue';

export default {
  name: 'FormFieldsCreditCard',
  components: {
    ValidatedInput,
    LocationSuggestions
  },
  data() {
    return {
      show_suggesions: false,
    }
  },
  props: {
    formFields: {
      type: Object,
      default: () => ({}),
    },
    errorResolver: {
      type: Function,
      default: () => [],
    },
    pickupLocation: {
      type: Object,
      default: () => ({}),
    },
    deliveryLocation: {
      type: Object,
      default: () => ({}),
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    nameSuggestion() {
      const firstName = this.customer?.contact?.firstName || '';
      const lastName = this.customer?.contact?.lastName || '';

      return `${firstName} ${lastName}`
    },
    addressSuggestions() {
      const address_suggestions = [];
      if (this.pickupLocation?.city) {
        address_suggestions.push({
          type: 'Pickup',
          city: this.pickupLocation.city,
          zip: this.pickupLocation.zip,
          state:  this.pickupLocation.state,
          address: this.pickupLocation.address,
        });
      }
      if (this.deliveryLocation?.city) {
        address_suggestions.push({
          type: 'Delivery',
          city: this.deliveryLocation.city,
          zip: this.deliveryLocation.zip,
          state:  this.deliveryLocation.state,
          address: this.deliveryLocation.address,
        });
      }
      return address_suggestions;
    },
  },
  methods: {
    handleInputChange({ field, newValue }) {
      const newFormFields = Object.assign({}, this.formFields);
      newFormFields[field] = newValue;
      this.$emit('input', newFormFields);

      if (field == 'city' || field == 'zip'){
        const searchTerm = ((newFormFields.zip || '') + ',' + (newFormFields.city || '')).trim()
        this.show_suggesions = searchTerm.length > 2
      }
    },
    handleSuggestion(item) {
      const newFormFields = { ...this.formFields, city: item.city, zip: item.zip };
      this.$emit('input', newFormFields);
      this.show_suggesions = false;
    },
    applyAddressSuggestion(suggestion) {
      const updatedFields = {
        city: suggestion.city || '',
        zip: suggestion.zip || '',
        address: suggestion.address || '',
      };
      const newFormFields = { ...this.formFields, ...updatedFields };
      this.$emit('input', newFormFields);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid--two-column {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
}
.grid--three-column {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
}

.clickable:hover {
  cursor: pointer;
  text-decoration: underline;
}

.suggestion-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 100;
  width: calc(66.66% - 6px);
}
</style>
